<template>
  <div class="lead-author">
    <div class="info-top">
      <div class="avatar-wrap" @click="routerProfile">
        <Avatar :src="leadAuthorInfo.avatar" :size="isMobile ? 44 : 55" />
      </div>
      <div class="name-wrap">
        <div class="name">
          <!-- <p class="nick-name" @click="routerProfile">{{leadAuthorInfo.nickname}}</p> -->
          <AuthorName class="nick-name" :uid="leadAuthorInfo.uid" :name="leadAuthorInfo.nickname" />
          <div
            color="more"
            size="small"
            :class="['follow-btn', {sub: isFollow}]" 
            @click="handleFollow"
            v-if="!isSelf"
          >
            <template v-if="isFollow">
              <i class="iconfont">&#xe63d;</i>已关注
            </template>
            <template v-else>
              <i class="iconfont">&#xe63e;</i>关注
            </template>
          </div>
        </div>
        <p class="mood">{{leadAuthorInfo.mood || '暂无标签'}}</p>
      </div>
    </div>
    <div class="info-intro">
      {{leadAuthorInfo.intro || '暂无简介'}}
    </div>
    <div class="nearly-list" v-if="!isMobile && leadAuthorInfo.list && leadAuthorInfo.list.length && !isTalk">
      <div class="line"></div>
      <div class="title">最新发布</div>
      <div class="list-item" v-for="item in leadAuthorInfo.list" :key="item.uuid">
        <ArticleTitle 
          :uuid="item.uuid || item.aid" 
          :type="item.ctype === 1 ? 1 : item.sub_type === 1 ? 2 : 0" 
          :title="item.article_title"
        />
        <div class="date">{{item.publish_time || item.ctime | date('near', 'YYYY 年 M 月 D 日')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import VueTypes from 'vue-types'
import gkButton from 'gkui/button'
import Avatar from '../../components/Avatar'
import FollowButton from '../../components/button/FollowButton'
import ArticleTitle from '../../components/title/ArticleTitle'
import AuthorName from '../../components/title/AuthorName'

import AccountService from '../../service/account.service'
export default {
  name: 'lead-author',
  components: {
    Avatar,
    gkButton,
    FollowButton,
    ArticleTitle,
    AuthorName
  },
  props: {
    leadAuthorInfo: VueTypes.object.def({}),
    follow: VueTypes.bool.def(false),
    isTalk: VueTypes.bool.def(false)
  },
  data () {
    return {
      loading: false,
      isFollow: this.follow
    }
  },
  computed: {
    ...mapState(['isMobile', 'loginUser']),
    isSelf () {
      return this.loginUser && this.loginUser.uid + '' === this.leadAuthorInfo.uid + ''
    }
  },
  watch: {
    follow (follow) {
      this.isFollow = follow
    }
  },
  created () {
  },
  methods: {
    handleFollow () {
      if (this.loading) {
        return
      }

      this.loading = true

      AccountService.followUser(this.leadAuthorInfo.uid, !this.isFollow).then(res => {
        this.isFollow = !this.isFollow
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    routerProfile () {
      window.open(`/profile/${this.leadAuthorInfo.uid}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/_common";
$color-border: #F0F1F3;
.lead-author {
  padding: 24px 20px;
  border: 1px solid $color-border; border-radius: 3px;
}

.info-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & .avatar-wrap {
    box-sizing: border-box;
    width: 61px; height: 61px;
    padding: 2px;
    border: 1px solid $color-border; border-radius: 50%;
    cursor: pointer;

    // & ::v-deep .com-avatar {
    //   width: 100%!important; height: 100%!important;
    //   object-fit: cover;
    //   object-position: center;
    // }

    & img {
      flex: 55px 0 0;
    }
  }

  & .name-wrap {
    flex: 1;
    overflow: hidden;
    margin-left: 12px;
  }

  & .name {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 26px;
    padding-right: 1px;
  }

  & .nick-name {
    @extend %row;
    @include font(20, 500);
    color: $lightBlack;
    cursor: pointer;

    &:hover {
      color: $blue;
    }
  }

  & .mood {
    margin-top: 6px;
    @include lineFont(16, 400);
    color: $lightBlack;
    line-height: 18px;
    @extend %row;
  }

  & .follow-btn {
    flex-shrink: 0;
    position: relative;
    width: 60px; height: 24px;
    border:1px solid $blue;
    border-radius: 3px;
    text-align: center;
    @include lineFont(14, 400);
    line-height: 25px;
    color: $blue;
    @extend %transition;
    cursor: pointer;
    user-select: none;

    & .iconfont {
      margin-right: 2px;
      font-size: 12px;
    }

    &.sub {
      width: 72px;
      border-color: #F0F1F3;
      color: $gray;
    }

    &:hover {
      color: $blueHover;
      border-color: $blueHover;
    }
  }

}

.info-intro {
  margin-top: 17px;
  @include font(14, 400);
  line-height: 21px;
  color: $gray;
}

.nearly-list {
  & .line {
    width: 100%;
    margin: 20px 0 24px;
    border-top: 1px solid $color-border;
  }

  & .title {
    position: relative;
    padding-left: 11px; margin-bottom: 15px;
    @include lineFont(16, 400);
    color: $lightBlack;

    &:before {
      content: '';
      position: absolute; top: 1px; left: 0;
      width: 3px; height: 14px;
      background: $blue;
    }
  }

  & .list-item {
    margin-top: 6px;

    & a {
      @include font(14, 400);
      line-height: 21px;
    }

    & .date {
      margin-top: 8px;
      @include lineFont(12, 400);
      color: $gray;
    }
  }

  & .list-item:not(:last-child) {
    padding-bottom: 12px;
    border-bottom: 1px solid $color-border;
  }
}

@media screen and (max-width: 768px) {
  .lead-author {
    padding: 16px;
  }

  .info-top {
    & .avatar-wrap {
      width: 50px; height: 50px;
      & img {
        flex: 44px 0 0;
      }
    }
    & .nick-name {
      font-size: 16px;
    }
    & .mood {
      font-size: 13px;
    }
  }
}
</style>